module.exports = __webpack_public_path__ + "img/pc_top_bg_2.81eb078.webp";